module.exports = __webpack_public_path__ + "static/img/rtc-ico-fail.2359d89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/rtc-ico-fail.png
// module id = h5EO
// module chunks = 1